export default __webpack_public_path__ + "static/postcards-star-6ce68ca33885681818c2303eaaff38f9.png";